"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "albisola-superiore": {
    "718bbe31": [{
      "hkey": "e874aee1",
      "slug": "luceto-carpineto",
      "name": "Luceto-Carpineto",
      "primary": true,
      "skipSearch": false
    }],
    "luceto": [{
      "hkey": "e874aee1",
      "slug": "luceto-carpineto",
      "name": "Luceto-Carpineto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;